module.exports = __webpack_public_path__ + "static/appstore-badge_en-2928664fe1fc6aca88583a6f606d60ba.svg";